import { useState, useEffect } from "react";
import PopuliLanding from "./PopuliLanding";
import PopuliVision from "./PopuliVision";
import PopuliBuild from "./PopuliBuild";

export default function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  // /vision is the new canonical path. /manifesto is kept so old links don't break.
  if (path === "/vision" || path === "/manifesto") return <PopuliVision />;
  // /build and /contribute both serve the contributor brief
  if (path === "/build" || path === "/contribute") return <PopuliBuild />;
  return <PopuliLanding />;
}
